import { useEffect, useState } from "react";
import { api, asArray } from "@/lib/api";
import { SeverityBadge, StatusBadge, KPI } from "@/components/Primitives";

export default function Vulnerabilities() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/security/vulnerabilities").then(r => setItems(asArray(r.data))); }, []);
  const open = items.filter(v=>v.status!=="patched").length;
  const crit = items.filter(v=>v.severity==="critical").length;
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Vulnerability Scanning</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Known CVEs ({items.length})</h1>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <KPI label="Open" value={open} tone="warn" testid="vuln-open"/>
        <KPI label="Critical" value={crit} tone="bad" testid="vuln-critical"/>
        <KPI label="Patched" value={items.length-open} tone="good" testid="vuln-patched"/>
        <KPI label="Avg CVSS" value={(items.reduce((a,c)=>a+c.cvss,0)/Math.max(items.length,1)).toFixed(1)} testid="vuln-cvss"/>
      </div>
      <div className="bg-zinc-950 border border-zinc-900 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 text-[10px] uppercase tracking-widest text-zinc-500 font-mono"><tr><th className="text-left px-4 py-3">CVE</th><th className="text-left px-4 py-3">Title</th><th className="text-left px-4 py-3">CVSS</th><th className="text-left px-4 py-3">Severity</th><th className="text-left px-4 py-3">Affected</th><th className="text-left px-4 py-3">Status</th></tr></thead>
          <tbody>
            {items.map(v => (
              <tr key={v.id} className="border-b border-zinc-900 hover:bg-zinc-900/40">
                <td className="px-4 py-2 font-mono text-xs text-blue-400">{v.cve_id}</td>
                <td className="px-4 py-2">{v.title}</td>
                <td className="px-4 py-2 font-mono">{v.cvss}</td>
                <td className="px-4 py-2"><SeverityBadge level={v.severity}/></td>
                <td className="px-4 py-2 font-mono text-xs">{v.affected_assets}</td>
                <td className="px-4 py-2"><StatusBadge status={v.status==='patched'?'resolved':'open'}/></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
